import { PersonOfInterest, DriverLicense } from '../types';

interface PersonModalProps {
  person: PersonOfInterest | null;
  onClose: () => void;
}

const PersonModal = ({ person, onClose }: PersonModalProps) => {
  if (!person) return null;

  // Get licenses - they should already be parsed by the backend
  const licenses: DriverLicense[] = Array.isArray(person.drivers_license_codes) 
    ? person.drivers_license_codes 
    : [];

  // Format date for display
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-6">Person of Interest Details</h3>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium text-gray-700">Name</p>
            <p className="text-sm text-gray-900">{person.name || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">Surname</p>
            <p className="text-sm text-gray-900">{person.surname || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">Email</p>
            <p className="text-sm text-gray-900">{person.email || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">Contact Number</p>
            <p className="text-sm text-gray-900">{person.contact_number || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">Designation</p>
            <p className="text-sm text-gray-900">{person.designation || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">Status</p>
            <p className="text-sm text-gray-900">{person.status || 'N/A'}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">ID/Passport Number</p>
            <p className="text-sm text-gray-900">{person.id_passport_number || 'N/A'}</p>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-700">Date of Birth</p>
            <p className="text-sm text-gray-900">
              {person.date_of_birth ? new Date(person.date_of_birth).toLocaleDateString('en-GB') : 'N/A'}
            </p>
          </div>

          {/* Driver's License Section */}
          <div>
            <p className="text-sm font-medium text-gray-700">Driver's License Codes</p>
            {licenses.length > 0 ? (
              <div className="space-y-2 mt-2">
                {licenses.map((license, index) => (
                  <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded border">
                    <span className="font-medium text-blue-600">{license.code}</span>
                    <span className="text-sm text-gray-600">
                      {license.dateOfFirstIssue ? `First issued: ${license.dateOfFirstIssue}` : 'No issue date'}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-900">N/A</p>
            )}
          </div>

        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonModal;